import { CommonSuspense } from '../../common/components/common-suspense.tsx';
import { ProfileScreenProtector } from '../../common/components/screen-protectors/profile-screen-protector.tsx';

import { HomeScreenLazy } from '../screens/home.screen.lazy.tsx';
import { LessonScreenLazy } from '../screens/lesson.screen.lazy.tsx';
import { LessonsCompletedScreenLazy } from '../screens/lessons-completed.screen.lazy.tsx';

export const LearnRouter = [
  {
    path: '/learn',
    element: (
      <CommonSuspense>
        <ProfileScreenProtector>
          <HomeScreenLazy />
        </ProfileScreenProtector>
      </CommonSuspense>
    ),
  },
  {
    path: '/learn/lesson',
    element: (
      <CommonSuspense>
        <ProfileScreenProtector>
          <LessonScreenLazy />
        </ProfileScreenProtector>
      </CommonSuspense>
    ),
  },
  {
    path: '/learn/lessons-completed',
    element: (
      <CommonSuspense>
        <ProfileScreenProtector>
          <LessonsCompletedScreenLazy />
        </ProfileScreenProtector>
      </CommonSuspense>
    ),
  },
];
